import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { HexColorPicker } from 'react-colorful';

interface ColorPickerDropdownProps {
  value: string;
  onChange: (color: string) => void;
  placeholder?: string;
  label?: string;
  className?: string;
  inputClassName?: string;
  required?: boolean;
}

const ColorPickerDropdown: React.FC<ColorPickerDropdownProps> = ({ value, onChange, placeholder, label, className, inputClassName, required }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Close dropdown on outside click
  React.useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div ref={ref} className={classNames('dropdown w-full', { 'dropdown-open': open }, className)}>
      {label && (
        <label className="label">
          <span className="label-text text-systemGrays02LabelSecondary">
            {label} {required && <span className="text-colorsBrandRed01Primary">*</span>}
          </span>
        </label>
      )}
      <div className="flex items-center space-x-2 cursor-pointer" onClick={() => setOpen((v) => !v)}>
        <div className="w-8 h-8 rounded border" style={{ background: value || '#fff' }} />
        <input
          type="text"
          className={classNames('input input-bordered w-full', inputClassName)}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder || '#000000'}
          onFocus={() => setOpen(true)}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
      {open && (
        <div className="dropdown-content z-50 rounded-md shadow top-[75px] left-0 absolute">
          <HexColorPicker color={value || '#000000'} onChange={onChange} />
        </div>
      )}
    </div>
  );
};

export default ColorPickerDropdown;
